import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const verifyCode = createAsyncThunk(
  "verification/verifyCode",
  async (code, { rejectWithValue, getState }) => {
    try {
      const tempVerificationToken =
        getState().verification.tempVerificationToken;
      if (!tempVerificationToken) {
        return rejectWithValue("Invalid verification session.");
      }

      const response = await axios.post(
        `${API_URL}/users/verify-phone/check`,
        { token: code },
        {
          headers: {
            Authorization: `Bearer ${tempVerificationToken}`,
          },
        }
      );

      localStorage.setItem("token", response.data.token);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Verification failed"
      );
    }
  }
);

export const resendVerificationCode = createAsyncThunk(
  "verification/resendVerificationCode",
  async (_, { rejectWithValue, getState }) => {
    try {
      const tempVerificationToken =
        getState().verification.tempVerificationToken;
      const phoneNumber = localStorage.getItem("phoneNumber");
      if (!tempVerificationToken || !phoneNumber) {
        return rejectWithValue(
          "Invalid session or phone number not found."
        );
      }

      await axios.post(
        `${API_URL}/users/verify-phone/send`,
        { phoneNumber: phoneNumber },
        {
          headers: {
            Authorization: `Bearer ${tempVerificationToken}`,
          },
        }
      );

      return { resendCodeSent: true };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Code could not be resent."
      );
    }
  }
);

const verificationSlice = createSlice({
  name: "verification",
  initialState: {
    tempVerificationToken: null,
    resendCodeLoading: false,
    resendCodeError: null,
    loading: false,
    error: null,
  },
  reducers: {
    setTempVerificationToken: (state, action) => {
      state.tempVerificationToken = action.payload;
    },
    clearVerificationError: (state) => {
      state.error = null;
      state.resendCodeError = null;
    },
    resetVerificationCodeSent: (state) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyCode.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.tempVerificationToken = null;
      })
      .addCase(verifyCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(resendVerificationCode.pending, (state) => {
        state.resendCodeLoading = true;
        state.resendCodeError = null;
      })
      .addCase(resendVerificationCode.fulfilled, (state, action) => {
        state.resendCodeLoading = false;
        state.resendCodeError = null;
      })
      .addCase(resendVerificationCode.rejected, (state, action) => {
        state.resendCodeLoading = false;
        state.resendCodeError = action.payload;
      });
  },
});

export const {
  setTempVerificationToken,
  clearVerificationError,
  resetVerificationCodeSent,
} = verificationSlice.actions;
export default verificationSlice.reducer;
